export default function TrustBar() {
  const signals = [
    { icon: 'ri-award-line', text: '100+ Years Combined Experience' },
    { icon: 'ri-map-pin-line', text: 'All Florida Markets' },
    { icon: 'ri-percent-line', text: 'Lowest Operational Cost In Industry' },
    { icon: 'ri-calendar-check-line', text: 'Onboarding in 30 Days' },
  ];

  return (
    <div className="bg-slate-900 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between py-4 gap-4 sm:gap-0">
          {signals.map((signal, index) => (
            <div key={index} className="flex items-center gap-2 group">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${signal.icon} text-amber-400 text-base`}></i>
              </div>
              <span className="text-xs font-light text-gray-300 tracking-wide whitespace-nowrap">{signal.text}</span>
              {index < signals.length - 1 && (
                <span className="hidden sm:block text-gray-600 ml-4 mr-0">│</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
